import _omit from 'lodash/omit';
import PropTypes from 'prop-types';

class DeleteButton extends React.Component {

  shouldComponentUpdate() {
    return true;
  };

  render() {
    return React.createElement('button', _omit(this.props, 'content'), this.props.content);
  }
}

DeleteButton.propTypes = {
  content: PropTypes.string
};

export default DeleteButton;